import { combineReducers } from 'redux';
import { checkoutAudioVideoReducer, ICheckoutAudioVideoState } from './audioVideo';
import { checkoutCardReducer, ICheckoutCardState } from './card';
import { checkoutAccountReducer, ICheckoutCollectState } from './collect';
import { checkoutCommonReducer, ICheckoutCommonState } from './common';
import { checkoutWalletReducer, ICheckoutWalletState } from './wallet';

export enum Service {
  AudioVideo,
  Wallet,
  PhoneCard,
  Collect,
  Visitation,
  MailConnect
}

export interface ICheckoutState {
  card: ICheckoutCardState
  collect: ICheckoutCollectState
  common: ICheckoutCommonState
  wallet: ICheckoutWalletState
  audioVideo: ICheckoutAudioVideoState
}

export const checkoutReducer = combineReducers<ICheckoutState>({
  card: checkoutCardReducer,
  collect: checkoutAccountReducer,
  common: checkoutCommonReducer,
  wallet: checkoutWalletReducer,
  audioVideo: checkoutAudioVideoReducer
});
